import React from "react";
import PropTypes from "prop-types";
import { Day } from "date-fns";
import {
  ReactDefaultProps,
  ReactComponentStaticProps,
} from "../../types/react";

import { generateLocalizedWeekdays } from "./utils/calendar";

import styles from "./DateRangePicker.scss";

export type CalendarHeaderProps = {
  locale?: string;
  firstDayOfWeek?: Day;
};

const defaultProps = {
  locale: "de-DE",
  firstDayOfWeek: 1,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  CalendarHeaderProps,
  typeof defaultProps
> = defaultProps;

const CalendarHeader: ((props: CalendarHeaderProps) => JSX.Element) &
  ReactComponentStaticProps<CalendarHeaderProps> = ({
  locale = defaultProps.locale,
  firstDayOfWeek = defaultProps.firstDayOfWeek,
}) => {
  const weekdays = generateLocalizedWeekdays(locale, firstDayOfWeek);

  return (
    <thead>
      <tr className={styles["calendar-row"]}>
        {weekdays.map((weekday) => (
          <th
            className={styles["calendar-weekday-cell"]}
            key={weekday.abbreviation}
            abbr={weekday.full}
            scope="col"
          >
            {weekday.abbreviation}
          </th>
        ))}
      </tr>
    </thead>
  );
};

CalendarHeader.propTypes = {
  locale: PropTypes.string,
  firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
};

CalendarHeader.defaultProps = validatedDefaultProps;

CalendarHeader.displayName = "DateRangePicker.CalendarHeader";

export default CalendarHeader;
